import { h, Fragment } from 'preact';
import PropTypes from 'prop-types';

import { splitClassName } from '../../../utils/classnames-utils';
import CtaSkeleton from '../../components/2-atoms/cta/cta-skeleton';
import { modifierList as cardModifierList } from '../../components/3-molecules/card/props-list';
import CardSkeleton from '../../components/3-molecules/card/card-skeleton';
import DropdownSkeleton from '../../components/3-molecules/dropdown/dropdown-skeleton';
import SetOfCards from '../../components/4-organisms/set-of-cards/set-of-cards';

const ParselySkeleton = ({ skeletonColor, setsOfCardsModifiers, cardModifiers, maxContents, isCtaActive }) => {
  const cards = Array(maxContents).fill(0);
  return (
    <Fragment>
      <DropdownSkeleton skeletonColor={skeletonColor} />
      <SetOfCards
        cards={cards}
        modifiers={splitClassName(setsOfCardsModifiers)}
        render={(_, index) => (
          <CardSkeleton key={index} skeletonColor={skeletonColor} modifiers={cardModifiers} hasTextBlock hasImage />
        )}
      />
      {isCtaActive && <CtaSkeleton skeletonColor={skeletonColor} />}
    </Fragment>
  );
};

ParselySkeleton.propTypes = {
  skeletonColor: PropTypes.string.isRequired,
  setsOfCardsModifiers: PropTypes.string.isRequired,
  cardModifiers: PropTypes.arrayOf(PropTypes.oneOf(cardModifierList)),
  maxContents: PropTypes.number.isRequired,
  isCtaActive: PropTypes.bool.isRequired,
};

export default ParselySkeleton;
